var exports = {
  "CG": "output-SjVMT",
  "kL": "container-SjVMT",
  "Zt": "highlight-SjVMT",
  "wP": "singleIcon-SjVMT",
  "RL": "iconGroup-SjVMT",
  "ws": "function_call-SjVMT",
  "cS": "functions_markdown-SjVMT",
};

module.exports = exports;
